const _temp0 = require("./presets/Acid House.grufpreset");
const _temp1 = require("./presets/Dub Reggae.grufpreset");
const _temp2 = require("./presets/Funky Soul.grufpreset");
const _temp3 = require("./presets/Hip Hop Classic 1.grufpreset");
const _temp4 = require("./presets/Hip Hop Classic 2.grufpreset");
const _temp5 = require("./presets/Pop corn.grufpreset");
const _temp6 = require("./presets/Power bass.grufpreset");
const _temp7 = require("./presets/Reggae Roots.grufpreset");
const _temp8 = require("./presets/Slow pad.grufpreset");
const _temp9 = require("./presets/Soul Pop.grufpreset");
const _temp10 = require("./presets/Taurus.grufpreset");
const _temp11 = require("./presets/Trap 1.grufpreset");
const _temp12 = require("./presets/Trap 2.grufpreset");
const _temp13 = require("./presets/Urban Reggaeton.grufpreset");
module.exports = {
  "Acid House": _temp0,
  "Dub Reggae": _temp1,
  "Funky Soul": _temp2,
  "Hip Hop Classic 1": _temp3,
  "Hip Hop Classic 2": _temp4,
  "Pop corn": _temp5,
  "Power bass": _temp6,
  "Reggae Roots": _temp7,
  "Slow pad": _temp8,
  "Soul Pop": _temp9,
  "Taurus": _temp10,
  "Trap 1": _temp11,
  "Trap 2": _temp12,
  "Urban Reggaeton": _temp13
}